import React from "react";
import { Button } from "reactstrap";
import classnames from "classnames";
import PropTypes from "prop-types";

import Icon from "shared/react_components/MaterialIcon";
import fileInKiB from "./helpers/fileInKiB";

const DropzoneFile = ({ file, onCancel }) => (
  <div
    className={classnames("dropzone-file", {
      "text-muted": !file.accepted
    })}
  >
    <Icon name="insert_drive_file" className="dropzone-icon" />
    <span className="dropzone-filename">{file.name}</span>
    <span className="dropzone-filesize">
      <strong>{fileInKiB(file.size)}</strong> KiB
    </span>
    <Button
      color="none"
      className="p-1 ml-2 dropzone-remove"
      onClick={() => onCancel(file)}
    >
      <Icon name="close" />
    </Button>
  </div>
);

DropzoneFile.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string,
    size: PropTypes.number,
    path: PropTypes.string,
    accepted: PropTypes.bool
  }).isRequired,
  onCancel: PropTypes.func.isRequired
};

export default DropzoneFile;
